// extracted by mini-css-extract-plugin
module.exports = {"main-wrapper":"layout-content_main-wrapper__eC6dE","main":"layout-content_main__VY6Rn","main__footer-wrapper":"layout-content_main__footer-wrapper__tiLgn"};